<template>
  <div class="chart">
    <div ref="lineChart" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
import * as echarts from "echarts/core";
export default {
  name: "lineChartView",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "350px",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "canvas",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
  },
  mounted() {
    this.initChart();
    if (this.autoResize) {
      window.addEventListener("resize", this.resizeHandler);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.resizeHandler);
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeHandler() {
      this.chart.resize();
    },
    initChart() {
      this.chart = echarts.init(this.$refs.lineChart, "", {
        renderer: this.type,
      });
      this.initChartOption();
      this.chart.on("click", this.handleClick);
    },
    initChartOption() {
      const _this = this;
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["牛", "羊", "家禽", "其他"],
          icon: "rect", //rect方形
          itemWidth: 14, // 设置宽度
          itemHeight: 4, // 设置高度
          itemGap: 20, // 设置间距
          textStyle: {
            color: "#ffffff",
            fontSize: 14,
          },
          right: "2%",
        },
        grid: {
          top: "13%",
          left: "0",
          right: "8%",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          name: "月",
          nameTextStyle: {
            color: "#b5dbff",
            fontSize: "14px",
          },
          boundaryGap: false,
          data: _this.data.month,
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#b5dbff",
            fontSize: 14,
          },
        },

        yAxis: {
          type: "value",
          name: "头",
          nameTextStyle: {
            color: "#b5dbff",
            fontSize: "14px",
          },
          min: 0,
          // max: 50,
          axisLine: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          // 设置数据间隔一个显示
          axisLabel: {
            color: "#b5dbff",
            fontSize: 12,
            interval: 2,
          },
        },
        series: [
          {
            name: "牛",
            type: "line",
            // stack: 'Total',
            showSymbol: false,
            data: _this.data.cattleCount,
            itemStyle: {
              color: "#00bbe9",
              lineStyle: {
                color: "#00bbe9",
              },
            },
          },
          {
            name: "羊",
            type: "line",
            // stack: 'Total',
            showSymbol: false,
            data: _this.data.sheepCount,
            itemStyle: {
              color: "#fcab2b",
              lineStyle: {
                color: "#fcab2b",
              },
            },
          },
          {
            name: "家禽",
            type: "line",
            // stack: 'Total',
            showSymbol: false,
            data: _this.data.poultryCount,
            itemStyle: {
              color: "#01cc67",
              lineStyle: {
                color: "#01cc67",
              },
            },
          },
          {
            name: "其他",
            type: "line",
            // stack: 'Total',
            showSymbol: false,
            data: _this.data.otherCount,
            itemStyle: {
              color: "#a867e6",
              lineStyle: {
                color: "#a867e6",
              },
            },
          },
        ],
      });
    },
    handleClick(params) {
      this.$emit("click", params);
    },
    setOptions() {
      this.clearChart();
      this.resizeHandler();
      if (this.chart) {
        this.initChartOption();
      }
    },
    refresh() {
      this.initChartOption();
    },
    clearChart() {
      this.chart && this.chart.clear();
    },
  },
};
</script>
